<template>
<div>
<p>Thank you for reading this sample.  Here are other books you might like.</p>
</div>
</template>
<script>
export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>


// WEBPACK FOOTER //
// last.vue?1f534828